import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      'nav.home': 'Home',
      'nav.create': 'Create',
      'nav.dashboard': 'Dashboard',
      'nav.login': 'Login',
      'nav.logout': 'Logout',
      'home.title': 'Snap 3D Generator',
      'home.subtitle': 'Transform your images into stunning 3D models',
      'home.cta': 'Start Creating',
      'create.title': 'Create 3D Model',
      'create.uploadImage': 'Upload Image',
      'create.generatePrompt': 'Generate from Prompt',
      'create.modes.image': 'Image to 3D',
      'create.modes.text': 'Text to 3D',
      'create.button.generate': 'Generate 3D Model',
      'create.button.generating': 'Generating...',
      'create.preview.title': '3D Preview',
      'create.progress.uploading': 'Uploading...',
      'create.progress.processing': 'Processing...',
      'create.progress.generating': 'Generating 3D model...',
      'create.errors.uploadImage': 'Please upload an image first',
      'create.errors.generationFailed': 'Generation failed, please try again',
      'dashboard.title': 'My Models',
      'dashboard.empty': 'No models yet. Create your first 3D model!',
      'dashboard.loginRequired': 'Please login to view your models',
      'common.download': 'Download',
      'common.delete': 'Delete',
      'common.cancel': 'Cancel',
      'common.confirm': 'Confirm',
    },
  },
  zh: {
    translation: {
      'nav.home': '首页',
      'nav.create': '创建',
      'nav.dashboard': '我的模型',
      'nav.login': '登录',
      'nav.logout': '退出',
      'home.title': 'Snap 3D 生成器',
      'home.subtitle': '将您的图片转换为精美的3D模型',
      'home.cta': '开始创建',
      'create.title': '创建3D模型',
      'create.uploadImage': '上传图片',
      'create.generatePrompt': '从提示词生成',
      'create.modes.image': '图片转3D',
      'create.modes.text': '文字转3D',
      'create.button.generate': '生成3D模型',
      'create.button.generating': '生成中...',
      'create.preview.title': '3D预览',
      'create.progress.uploading': '上传中...',
      'create.progress.processing': '处理中...',
      'create.progress.generating': '正在生成3D模型...',
      'create.errors.uploadImage': '请先上传图片',
      'create.errors.generationFailed': '生成失败，请重试',
      'dashboard.title': '我的模型',
      'dashboard.empty': '还没有模型，创建您的第一个3D模型吧！',
      'dashboard.loginRequired': '请登录后查看您的模型',
      'common.download': '下载',
      'common.delete': '删除',
      'common.cancel': '取消',
      'common.confirm': '确认',
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'zh',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
